import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import Loader from "../components/Loader";
import OwlCarousel from "react-owl-carousel";
import { Link, useLocation } from "react-router-dom";
import { RemovePlusFromString } from "../helper/RemovePlusFromString";
import ComingSoon from "../components/ComingSoon";
import { useTranslate } from "../components/TranslationText";
import { showWordsByNumber } from "../helper/showFirstSixWords";
import Popup from "reactjs-popup";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { ProgressBar } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import CustomSlider from "../components/customSlider/customSlider";
import WahoConfernceCard from "../components/WahoConfernceCard";

const BaseBACKENDURL = process.env.REACT_APP_BACKEND_API;
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function WahoConference() {
  const { translate } = useTranslate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

  const WahoConferenceID = process.env.REACT_APP_WahoConference_ID;

  const id = WahoConferenceID;

  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const [wahoConference, setWahoConference] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [programDivActive, setProgramDivActive] = useState(0);
  const [programCardList, setProgramCardList] = useState([]);
  const [tourList, setTourList] = useState([]);
  const [postTourList, setPostTourList] = useState([]);




  useEffect(() => {
    const lang = searchParams.has("lang") ? searchParams.get("lang") : false;
    if (!!lang) {
      const previousLang = localStorage.getItem("eahsLang") ?? 'en';
      if (previousLang != lang) {
        localStorage.setItem("eahsLang", lang);
        window.location.reload();
      }
    }
    async function getdata() {
      const umbraco = await axios.get(
        `/umbraco/delivery/api/v1/content/item?id=${id}`,);
      const formattedData = umbraco.data?.map((item) => ({
        headerImage: item?.properties?.headerImage[0]?.url ?? "",
        headerText: item?.properties?.headerText ?? "",
        estmeemedGustsTitle: item?.properties?.estmeemedGustsTitle ?? "",
        estmeemedGustsDescription:
          item?.properties?.estmeemedGustsDescription?.markup ?? "",
        aboutTitle: item?.properties?.aboutTitle ?? "",
        aboutDescription: item?.properties?.aboutDescription?.markup ?? "",
        visaDescription: item?.properties?.visaDescription?.markup ?? "",
        visaPdf: item?.properties?.visaPdf ?? "",
        estmeemedFile: item?.properties?.estmeemedFile ?? "",
        postToursFile: item?.properties?.postToursFile ?? "",
        programFile: item?.properties?.programFile ?? "",
        addressTitle: item?.properties?.addressTitle ?? "",
        address: item?.properties?.address ?? "",
        startDateLable: item?.properties?.startDateLable ?? "",
        startDateDate: item?.properties?.startDateDate ?? "",
        endDateLabel: item?.properties?.endDateLabel ?? "",
        endDateDate: item?.properties?.endDateDate ?? "",
        footerTitle: item?.properties?.footerTitle ?? "",
        footerEmailTitle: item?.properties?.footerEmailTitle ?? "",
        footerEmailDescription: item?.properties?.footerEmailDescription ?? "",
        footerPhoneTitle: item?.properties?.footerPhoneTitle ?? "",
        footerPhoneDescription: item?.properties?.footerPhoneDescription ?? "",
        footerContactName: item?.properties?.footerContactName ?? "",
        footerRegisterEmail: item?.properties?.footerRegisterEmail ?? "",
        footerMessage: item?.properties?.footerMessage ?? "",
        sponsorLable: item?.properties?.sponsorLable ?? "",
        sponsorList: item?.properties?.sponsorList ?? [],
        programLable: item?.properties?.programLable ?? "",
        programList: item?.properties?.programList ?? [],

        programCardList: item?.properties?.programCardList ?? [],
        tourLable: item?.properties?.tourLable ?? "",
        tourList: item?.properties?.tourList ?? [],
        postTourLable: item?.properties?.postTourLable ?? "",
        postTourList: item?.properties?.postTourList ?? [],
        registrationLable: item?.properties?.registrationLable ?? "",
        registrationList: item?.properties?.registrationList ?? [],
        galleryLabel: item?.properties?.galleryLabel ?? "",
        galleryList: item?.properties?.galleryList ?? [],
        footerImage: item?.properties?.footerImage[0]?.url ?? "",
      }));

      setWahoConference(formattedData);

      let program_Card_List = formattedData[0].programCardList.filter(
        (item) =>
          item.properties.programCardDay ===
          formattedData[0].programList[0].properties.dayKey
      );
      setProgramCardList(program_Card_List);


      setTourList(formattedData[0].tourList);
      setPostTourList(formattedData[0].postTourList);

      // console.log(umbraco.data);
      // console.log(formattedData);

      if (umbraco.data.length > 0) {
        setloaded(true);
      }
    }
    getdata();
  }, [currentLanguage]);

  function getcarouselOptions(responsive1000, totalcards, isDays = false) {
    let iscenter = false;
    if (totalcards < responsive1000) {
      iscenter = true;
      if (totalcards > 1) {
        iscenter = false;
        responsive1000 = totalcards;
      }
    }
    return {
      loop: false,
      margin: isDays ? 0 : 5,
      nav: false,
      center: iscenter,
      autoplay: false,
      dots: true,
      dotsEach: true,
      responsive: {
        0: {
          items: isDays ? 1 : 1,
        },
        600: {
          items: isDays ? 2 : 2,
        },
        700: {
          items: isDays ? 3 : responsive1000,
        },
        900: {
          items: isDays ? responsive1000 - 3 : responsive1000,
        },
        1000: {
          items: isDays ? responsive1000 - 2 : responsive1000,
        },
        1068: {
          items: isDays ? responsive1000 - 1 : responsive1000,
        },
        1378: {
          items: responsive1000,
        }
      },
    };
  }

  const carouselRef = useRef(null);

  const handleInitialized = () => {
    // Seek to the initial tab only after initialization
    if (carouselRef.current) {

      carouselRef.current.to(programDivActive);

    }
  };


  function formatDay(_date) {
    let day = new Date(_date).getDate();

    return day;
  }

  function formatMonth(_date) {
    let month = new Date(_date).toLocaleString(
      currentLanguage === "en" ? "en-us" : "ar-ae",
      { month: "short" }
    );

    return month;
  }

  function formatYear(_date) {
    let year = new Date(_date).getFullYear();

    return year;
  }

  const handleProgramCardList = async (day, index) => {
    await setProgramDivActive(index);
    await setProgramCardList(
      wahoConference[0].programCardList.filter(
        (item) => item.properties.programCardDay === day
      )
    );
  };


  function getProgramListOrdered(list) {
    if (currentLanguage == 'ar') {
      return list.reverse();
    }
    else {
    }
    return list;
  }

  const tabsClasses = "col-xl-2-5 col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0";

  return (
    <>
      {loaded ? (
        <React.Fragment>
          {wahoConference.map((item, itemIndex) => (
            <>
              <div className="border-15 bg-white p-main p-3">
                <div className="row">
                  {
                    //image
                  }
                  <div className="col-sm-12 mb-main" >
                    <img
                      alt={"waho conference img"}
                      className="w-100 border-15 "
                      //src={`${MediaBaseURL}/assets/img/horsemarket.jpg`}
                      src={`${MediaBaseURL}${item.headerImage}`}
                    />
                  </div>

                  {
                    //Dear Esteemed Guests
                  }
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center mb-main">
                    <div className="mainSpacer  mb-main" />
                    <h2 className="bold rtl capatalise  text-start">{item.estmeemedGustsTitle}</h2>
                    <p className="text-start serviceLabelVal" >{showWordsByNumber(item.estmeemedGustsDescription, 67)}
                    </p>
                    <Link className="btn btn-outline-danger fw-bold" to={`${MediaBaseURL}${wahoConference[0]?.estmeemedFile}`} target="_blank">
                      {translate('web.viewInvitationLetter', 'View Invitation Letter')}
                    </Link>
                  </div>
                  {
                    //Program
                  }
                  {item.programList.length > 0 &&
                    <>
                      <h2 className="bold rtl capatalise  text-start">
                        {item.programLable}
                      </h2>
                      <CustomSlider
                        items=
                        {!!item.programList &&
                          item.programList.length > 0 &&
                          getProgramListOrdered(item.programList)
                        }
                        formatDay={formatDay}
                        formatMonth={formatMonth}
                        formatYear={formatYear}
                        handleProgramCardList={handleProgramCardList}
                        tabsClasses={tabsClasses}
                        programDivActive={programDivActive}
                        type="days"
                      />
                    </>}
                  {
                    //Program Cards
                  }
                  {programCardList.map(
                    (itemProgramCard, itemProgramCardIndex) => (
                      <WahoConfernceCard
                        key={itemProgramCardIndex}
                        title={itemProgramCard.properties?.programCardTitle}
                        time={itemProgramCard.properties?.programCardTime}
                        paragraph={itemProgramCard.properties?.programCardDescription}
                      />
                    ))}

                  <div className="col-md-12 col-sm-12 text-center mb-main">
                    <Link className="btn btn-outline-danger fw-bold  text-capitalize" to={`${MediaBaseURL}${wahoConference[0]?.programFile}`} target="_blank">
                      {translate('web.viewFullProgram', 'View Full Program')}
                    </Link>
                  </div>

                  {postTourList.length > 0 &&
                    <div className="col-md-12 col-sm-12">
                      <h2 className="bold text-start">{item.postTourLable}</h2>
                      <CustomSlider items={postTourList} type="wahopre" />
                    </div>
                  }

                  {
                    //Tour
                  }
                  {tourList.length > 0 &&
                    <div className="col-md-12 col-sm-12 mt-4">
                      <h2 className="bold text-start">{item?.tourLable}</h2>
                      <CustomSlider items={tourList} type="wahopre" />
                    </div>
                  }
                  <div className="col-md-12 col-sm-12 text-center mb-main">
                    <Link className="btn btn-outline-danger  text-capitalize" to={`${MediaBaseURL}${wahoConference[0]?.postToursFile}`} target="_blank">
                      {translate('web.viewToursBrochure', 'View Tours Brochure')}
                    </Link>
                  </div>



                  {!!item.visaPdf && <div className="col-md-12 col-sm-12 text-center mb-main">
                    <Link className="btn btn-outline-danger text-capitalize " to={`${MediaBaseURL}${item.visaPdf}`} target="_blank">
                      {translate('web.visaFlyer', 'View VISA INFORMATION FOR YOUR ASSISTANCE').toLowerCase()}
                    </Link>
                  </div>}


                  {
                    //Footer
                  }
                  <div className="mainSpacer  mb-main"></div>
                  <div
                    className="col-md-12 col-sm-12 text-start text-uppercase rtl"

                  >
                    <h4 className="bold lh-lg text-uppercase">{item.footerTitle}</h4>
                    <div className="row mb-form-group">
                      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-md-0 mb-sm-2 mb-2">
                        <i className=" fa-solid fa-user red"></i>
                        <span className="bold">
                          {translate('web.contactName', 'Contact Name')}:
                        </span>
                        <span className="fw-bold"> {item.footerContactName}</span>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-md-0 mb-sm-2 mb-2">
                        <i className="fa-regular fa-envelope red"></i>
                        <span className="bold">
                          {item.footerEmailTitle}:
                        </span>
                        <Link to={`mailto:${item.footerEmailDescription}`} className="red fw-bold" >
                          <span> {item.footerEmailDescription}</span>
                        </Link>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-md-0 mb-sm-2 mb-2" >
                        <i className=" fa-solid fa-phone red"></i>
                        <span className="fw-bold">
                          {item.footerPhoneTitle}:
                        </span>
                        <Link to={`tel:${item.footerPhoneDescription}`} className="red fw-bold">
                          <span> {RemovePlusFromString(item.footerPhoneDescription)}</span>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <span className="bold" >{item.footerMessage}  </span>
                        <span className="bold" >
                          <Link to={`mailto:${item.footerRegisterEmail}`} className="red" >
                            <span> {item.footerRegisterEmail}</span>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
        </React.Fragment>

      ) : (
        <Loader />
      )}
    </>
  );

  function getStartPosition(item) {
    return programDivActive;
  }
}
